import { Box, Button, Grid } from '@mui/material';
import Modal, { ModalProps } from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';
import { ModalBoxStyle } from './styles';

export interface ModalBoxProps extends ModalProps {
	onCancel: () => void;
	onSubmit: () => void;
}

const ModalBox = ({
	open,
	onClose,
	children,
	onCancel,
	onSubmit,
}: ModalBoxProps) => {
	const { t } = useTranslation();

	return (
		<>
			<Modal open={open} onClose={onClose}>
				<Box sx={ModalBoxStyle}>
					<Grid
						container
						direction="column"
						alignItems="center"
						spacing={3}
					>
						{children}
						<Grid
							container
							item
							direction="row"
							justifyContent="space-around"
						>
							<Grid item xs={5}>
								<Button
									fullWidth
									disableRipple
									variant="outlined"
									onClick={onCancel}
								>
									{t('form.cancel')}
								</Button>
							</Grid>
							<Grid item xs={5}>
								<Button
									fullWidth
									disableRipple
									variant="contained"
									onClick={onSubmit}
								>
									{t('form.confirm')}
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			</Modal>
		</>
	);
};

export default ModalBox;
